import './basic_link.less';

import noop from 'lodash/noop';
import React from 'react';
import classNames from 'classnames';

import Tipsy from 'zoomforth_component_lib/tipsy.jsx';


const BasicLink = ({ className, dark, tooltip, tooltipPosition, disabled, onClick, children, ...rest })=> {

  const a = (
    <a 
      {...rest} 
      className={classNames(
        'basic-link',
        className,
        {
          disabled: disabled,
          dark: dark
        }
      )}
      tabIndex={disabled ? '-1' : '0'}
      onClick={disabled ? noop : onClick}
      onFocus={disabled ? (e)=> { e.target.blur(); } : null}
    >

      {children}

    </a>
  );

  if (tooltip)  {

    return (
      <Tipsy content={tooltip} placement={tooltipPosition}>
        { a }
      </Tipsy>
    );

  } else {
    return a;
  }
};

BasicLink.defaultProps = {
  tooltipPosition: 'bottom'
};

export default BasicLink;
